export enum BonusAmountTypeEnum {
  PERCENT = 1,
  FIXED = 2,
}
